module.exports = __webpack_public_path__ + "static/media/corner_right_bg.290032f2.svg";